import { render, staticRenderFns } from "./ownerDetailAccountReceipt.vue?vue&type=template&id=fa9d98c8"
import script from "./ownerDetailAccountReceipt.vue?vue&type=script&lang=js"
export * from "./ownerDetailAccountReceipt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports